import ApiSignals, { ApiSignalFetchers } from "@/apis/api_signals"
import { computed } from "@preact/signals"
import { createLogger } from "@/utils/logger"
import { toast } from "react-toastify"

const logger = createLogger("")

async function addAccounts(params: FinanceAccountApiTypes.Fetcher.Query.AddAccountsParams) {
    try {
        await ApiSignalFetchers.addDataSignalAccounts(params)
    } catch (e) {
        toast((e as Error).message, { type: "error" })
    }
}

const success = computed(() => {
    return ApiSignals.dataSignalAddAccounts.value?.status
})

export { addAccounts, success }
